import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TablePictureEnum, TableTypeConfigModel } from 'src/app/resy-modul/enums/table-picture.enum';
import { CreateOrEditCapacityModel } from 'src/app/resy-modul/models/tables/create-or-edit-capacity.model';
import { TableGroupModel } from 'src/app/resy-modul/models/tables/table-group.model';
import { TableTypeModel } from 'src/app/resy-modul/models/tables/table-type.model';
import { VenueService } from "../../../services/venues/venue.service";
import {
  CdkDragStart,
  CdkDragMove,
  CdkDragDrop,
  moveItemInArray,
  copyArrayItem,
} from '@angular/cdk/drag-drop';
import { DeleteGroupConfirmComponent } from "./delete-group-confirm/delete-group-confirm.component";
import { EditTableComponent } from './edit-table/edit-table.component';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-create-capacity-for-venues',
  templateUrl: './create-capacity-for-venues.component.html',
  styleUrls: ['./create-capacity-for-venues.component.scss']
})
export class CreateCapacityForVenuesComponent implements OnInit {

  //#region Fields
  public dragedTable: TableTypeModel;
  public tablePicture: Array<TableTypeModel> = new Array<TableTypeModel>();
  public startX: string;
  public startY: string;
  public selectedGroup: TableGroupModel = new TableGroupModel();
  public addTableGroup: TableGroupModel;
  public showAddGroup: boolean;
  public showUpdateGroup: boolean;
  public createOrEditCapacityModel: CreateOrEditCapacityModel = new CreateOrEditCapacityModel();
  public venueId: string;
  public enableEdit: boolean = false;
  public fromAddVenue: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();

  //#endregion

  //#region Constructor
  constructor(
    public translate: TranslateService,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private venueService: VenueService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.venueId = this.config.data.id;
    }

    if (this.config.data != undefined && this.config.data.fromAddVenue) {
      this.fromAddVenue = this.config.data.fromAddVenue;
    }

    if (this.config.data != undefined && this.config.data.name) {
      this.createOrEditCapacityModel.name = this.config.data.name;
    }

    if (this.config.data != undefined && this.config.data.startDate) {
      this.createOrEditCapacityModel.startDate = this.config.data.startDate;
    }

    if (this.config.data != undefined && this.config.data.endDate) {
      this.createOrEditCapacityModel.endDate = this.config.data.endDate;
    }

    if (this.config.data != undefined && this.config.data.startTime) {
      this.createOrEditCapacityModel.startTime = this.config.data.startTime;
    }

    if (this.config.data != undefined && this.config.data.endTime) {
      this.createOrEditCapacityModel.endTime = this.config.data.endTime;
    }

    if (this.config.data != undefined && this.config.data.hasOwnProperty('default')) {
      this.createOrEditCapacityModel.isDefault = this.config.data.default;
    }

    this.addTableGroup = new TableGroupModel();
    this.createOrEditCapacityModel.capacityGroups = new Array<TableGroupModel>();

    if (this.config.data != undefined && this.config.data.capacityConfig) {
      this.convertAndSetCapacity(this.config.data.capacityConfig);
      this.enableEdit = true;
    }
  }

  ngOnInit(): void {
    const el = document.getElementsByClassName('p-dialog-mask');
    el[el.length - 1].classList.add('justify-content-start-mbl');

    Object.entries(TablePictureEnum).filter(t => isNaN(+t)).forEach((tableType: string[]) => {
      let table = new TableTypeModel();
      table.type = tableType[0];
      table.shape = tableType[1];
      table.numberOfPeople = TableTypeConfigModel[tableType[0] as keyof typeof TableTypeConfigModel].value;
      this.tablePicture.push(table)
    });
  }
  //#endregion

  //#region Public Methods
  openAddGroup() {
    this.showAddGroup = true;
  }

  closeAddGroup() {
    this.showAddGroup = false;
    this.showUpdateGroup = false;
    this.addTableGroup = new TableGroupModel();
  }

  addGroup() {
    if (this.addTableGroup.name) {
      this.selectedGroup = this.addTableGroup
      this.addTableGroup.index = this.createOrEditCapacityModel.capacityGroups.length !=0 ? Math.max(...this.createOrEditCapacityModel.capacityGroups.map(o => o.index)) + 1 : 1;
      this.addTableGroup.capacityTables = new Array<TableTypeModel>();
      this.createOrEditCapacityModel.capacityGroups.push(this.addTableGroup)
      this.addTableGroup = new TableGroupModel();
      this.showAddGroup = false;
    }
  }

  openUpdateGroup(model: TableGroupModel) {
    this.addTableGroup = model
    this.showAddGroup = true;
    this.showUpdateGroup = true;
  }

  updateGroup(model: TableGroupModel) {
    if (model.name) {
      this.createOrEditCapacityModel.capacityGroups.find(c => c.index === model.index )?.name === model.name;
      this.addTableGroup = new TableGroupModel();
      this.showAddGroup = false;
      this.showUpdateGroup = false;
    }
  }
  reloadCapacity(){
    this.venueService.viewVenueCapacity(this.venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.createOrEditCapacityModel = response;
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  removeGroup(groupIndex: number) {
    const ref = this.dialogService.open(DeleteGroupConfirmComponent, {
      width: '380px',
      showHeader: false,
      styleClass: 'dialog_long'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        if (!this.isGroupDeleteDisabled(groupIndex)) {
          if(this.selectedGroup.index == groupIndex){
            this.selectedGroup = new TableGroupModel()
          }
          this.createOrEditCapacityModel.capacityGroups = this.createOrEditCapacityModel.capacityGroups.filter(c => c.index !== groupIndex);
        }
      }
    });
  }

  dragStart(e: any, t: any) {
    this.startX = e.offsetX;
    this.startY = e.offsetY;
    this.dragedTable = new TableTypeModel();
    this.dragedTable = t;
    this.confirmationService.close();
  }

  dragEnd(e: any) {

  }

  drop(e: any) {
    if(this.createOrEditCapacityModel.capacityGroups.length == 0){

    }
    else if (this.dragedTable) {

      let table = new TableTypeModel();
      table.id = this.dragedTable.id;
      table.index = this.dragedTable.index;
      table.type = this.dragedTable.type;
      table.name = this.dragedTable.name;
      table.shape = this.dragedTable.shape;
      table.yPosition = this.dragedTable.yPosition;
      table.xPosition = this.dragedTable.xPosition;
      if(this.dragedTable.numberOfPeople != undefined){
        table.numberOfPeople = this.dragedTable.numberOfPeople;
      }else{
        table.numberOfPeople = TableTypeConfigModel[this.dragedTable.type as keyof typeof TableTypeConfigModel].value;
      }
      let top = ((parseInt(e.layerY)) - parseInt(this.startY));
      let left = ((parseInt(e.layerX)) - parseInt(this.startX));

      if ((top >= 80 && top <= 420) && (left >= 175 && left <= 920)) {
        table.yPosition = top + 'px';
        table.xPosition = left + 'px';
        if (this.selectedGroup.capacityTables.find(t => t.index === table.index)) {
          this.selectedGroup.capacityTables = this.selectedGroup.capacityTables.filter(t => t.index !== table.index);
        }
        else {
          table.index = this.selectedGroup.capacityTables.length + 1;
        }
        this.selectedGroup.capacityTables.push(table);
      }

      this.dragedTable = new TableTypeModel();
    }
  }

  editTable() {

  }
  deleteTable() {

  }

  onDoubleClick(event: any, table: any) {
    if ((table.status === undefined || table.status === null) || table.status === 1) {
      this.confirmationService.confirm({
        target: event.target,
        rejectLabel: this.translate.instant("EDIT"),
        acceptLabel: this.translate.instant("DELETE"),
        defaultFocus: 'reject',
        rejectButtonStyleClass: 'accept-button-style-class',
        acceptButtonStyleClass: 'accept-button-style-class',
        accept: () => {
          if (this.selectedGroup.capacityTables.find(t => t.index === table.index)) {
            this.selectedGroup.capacityTables = this.selectedGroup.capacityTables.filter(t => t.index !== table.index);
            this.selectedGroup.capacityTables.forEach((table, index) => table.index = index+1);
          }
        },
        reject: () => {
          if(this.selectedGroup.capacityTables.find(t => t.index === table.index)){
          const t = this.selectedGroup.capacityTables.find(t => t.index === table.index);
          
          const ref = this.dialogService.open( EditTableComponent, {
            data: {
              tableName: t?.name,
              tableId: t?.id
            },
            width: '380px',
            showHeader: false,
            styleClass: 'dialog_long'
          });
          ref.onClose.subscribe((response: any) => {
              if(response.tableName != undefined && table.id != undefined){
                this.createOrEditCapacityModel.capacityGroups.forEach((group: any) =>{
                  group.capacityTables.forEach((tab: any) => {
                      if(tab.id == table.id){
                        tab.name = response.tableName;
                      }
                  });
              });
            }
              if(response.tableName != undefined && table.id == undefined){
                let editTable = this.createOrEditCapacityModel.capacityGroups.find((g: any) => g.id == this.selectedGroup.id)?.capacityTables.find(t => t.index == table.index);
                if(editTable != undefined){
                  editTable.name = response.tableName;
                }
              }
          }); 
        }
      }  
      });
    } else {
      this.confirmationService.confirm({
        target: event.target,
        rejectVisible: false,
        acceptLabel: 'This table cannot be deleted',
        defaultFocus: 'reject',
        acceptButtonStyleClass: 'accept-message-style-class',
        accept: () => {
          //confirm action
        },
        reject: () => {
          //reject action
        }
      });
    }
  }

  save(model: CreateOrEditCapacityModel) {
    model.venueId = this.venueId;

    model.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = +x.xPosition.toString().replace('px', '');
        x.yPosition = +x.yPosition.toString().replace('px', '');
      });
    });

    this.ref.close(model);
  }

  updateOrDeleteCapacity(model: CreateOrEditCapacityModel) {
    model.venueId = this.venueId;

    model.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = parseInt(x.xPosition.toString().replace('px', ''));
        x.yPosition = parseInt(x.yPosition.toString().replace('px', ''));
      });
    });

    if (model.id) {
      this.venueService.updateCapacity(model)
        .subscribe({
          next: (response) => {
            this.ref.close(model);
          },
          error: errorResponse => {
            this.ref.close(errorResponse);
          }
        });
    } else {
      this.venueService.createCapacity(model)
        .subscribe({
          next: (response) => {
            this.ref.close(model);
          },
          error: errorResponse => {
            this.ref.close(errorResponse);
          }
        });
    }
  }

  cancel(): void {
    this.ref.close(false);
  }

  convertAndSetCapacity(response: CreateOrEditCapacityModel): void {
    if (!response) {
      return;
    }
    const clonedResponse: CreateOrEditCapacityModel = JSON.parse(JSON.stringify(response));
    clonedResponse.capacityGroups.forEach(group => {
      group.capacityTables.forEach(x => {
        x.xPosition = x.xPosition + 'px';
        x.yPosition = x.yPosition + 'px';
        const type = Object.keys(TablePictureEnum).find((y: string) => TablePictureEnum[y as keyof typeof TablePictureEnum] == x.shape);
        x.type = type ? type : '';
      });
    });
    this.createOrEditCapacityModel = clonedResponse;
    if (this.createOrEditCapacityModel.capacityGroups.length > 0) {
      this.selectedGroup = this.createOrEditCapacityModel.capacityGroups[0];
    }
  }

  isGroupDeleteDisabled(groupIndex: number): boolean {
    let disabled = false;
    this.createOrEditCapacityModel.capacityGroups.find(c => c.index === groupIndex)?.capacityTables.forEach((table: TableTypeModel) => {
      if (table.status && table.status !== 1) {
        disabled = true;
      }
    });
    return disabled;
  }
  //#endregion

  //#region Mobile drag and drop
  @ViewChild('dropZone', { read: ElementRef, static: true })
  dropZone: ElementRef;

  _currentIndex: any;
  _currentField: any;
  isPointerOverContainer: boolean;
  _pointerPosition: { x: number; y: number; };

  // types = [{ text: 'drag me', top: 0, left: 0 }, { text: 'drag me2', top: 0, left: 0 }];

  // fields: any[] = [];

  moved(event: CdkDragMove) {
    this._pointerPosition = event.pointerPosition;
  }
  itemDropped(event: CdkDragDrop<any[]>) {

    if (event.previousContainer === event.container) {
      moveItemInArray(this.selectedGroup.capacityTables, event.previousIndex, event.currentIndex);
    } else {
      event.item.data.yPosition =
        this._pointerPosition.y -
        this.dropZone.nativeElement.getBoundingClientRect().top +
        'px';
      event.item.data.xPosition =
        this._pointerPosition.x -
        this.dropZone.nativeElement.getBoundingClientRect().left +
        'px';
      event.item.data.index = this.selectedGroup.capacityTables.length + 1;
      this.addField({ ...event.item.data }, event.currentIndex);
    }
  }

  addField(fieldType: any, index: number) {
    this.selectedGroup.capacityTables.splice(index, 0, fieldType)
  }

  changePosition(event: CdkDragDrop<any>, field: any) {

    const rectZone=this.dropZone.nativeElement.getBoundingClientRect()
    const rectElement=event.item.element.nativeElement.getBoundingClientRect()

    let yPosition=+field.yPosition.replace('px','')+event.distance.y
    let xPosition=+field.xPosition.replace('px','')+event.distance.x

    const out=yPosition<0 || xPosition<0 || (yPosition>(rectZone.height-rectElement.height)) || (xPosition>(rectZone.width-rectElement.width))
    if (!out)
    {
       field.yPosition=yPosition+'px'
       field.xPosition=xPosition+'px'
    }
    else{
       this.selectedGroup.capacityTables=this.selectedGroup.capacityTables.filter(x=>x!=field)
    }
  }
  //#endregion
}
